import { render, staticRenderFns } from "./HandleCommentModel.vue?vue&type=template&id=17e4df4d&scoped=true"
import script from "./HandleCommentModel.vue?vue&type=script&lang=js"
export * from "./HandleCommentModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e4df4d",
  null
  
)

export default component.exports